import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../../services/api';
import { ProjectList } from '.';
import { Project } from '../../types/ProjectType';
import { LoadingContext } from '../../providers/loading';
import { UserDataContext } from '../../providers/userData';
import { AuthContext } from '../../providers/auth';

export function ProjectListContainer() {
  const navigate = useNavigate();
  const { contractId } = useParams();
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const { userData } = useContext(UserDataContext);
  const { setState } = useContext(AuthContext);
  const [projectsData, setProjectsData] = useState<Project[]>([]);
  const [isEditProjectModalOpen, setIsEditProjectModalOpen] = useState(false);
  const [onEditProject, setOnEditProject] = useState<Project>(Object);

  async function getProjectsData() {
    setIsLoading({ value: true });
    await api.get(`/contracts/${contractId}/projects`, {
      headers: {
        'Authorization': `Bearer ${userData.token}`
      }
    })
      .then(response => {
        setProjectsData(response?.data?.projects);
      })
      .catch((error) => {
        console.log(error);
        setState({ userIsLogged: false });
        localStorage.removeItem('user');
        navigate('/');
      });

    setIsLoading({ value: false });
  }

  function onEdit(project: Project) {
    setIsEditProjectModalOpen(true);
    if (project) {
      setOnEditProject(project);
    }
  }

  async function onDelete(projectRow: Project) {
    const { id, contract_id } = projectRow;
    setIsLoading({ value: true });
    await api.delete(`/contracts/${contract_id}/projects?id=${id}`)
      .then(() => {
        getProjectsData();
      })
      .catch(error => console.log(error));
  }

  async function handleDuplicate(project: Project) {
    console.log(project);
    setIsLoading({ value: true });
    await api.post(`/duplicate_project/${project.id}`)
      .then(() => getProjectsData())
      .catch(error => console.log(error));
  }

  function goToProject(project: Project) {
    const { id } = project;
    navigate(`/contracts/${contractId}/project/${id}`);
  }

  async function fetchCsvFile(project: Project) {
    const { id, title } = project;

    try {
      await api.get(`/file?id=${id}&name=${title}`, {
        responseType: 'blob'
      })
        .then((response) => {
          console.log(response);

          if (response?.status === 200) {
            const url = window.URL.createObjectURL(response?.data);
            window.open(url);
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getProjectsData();
  }, []);

  return (
    <ProjectList
      isLoading={isLoading.value}
      projects={projectsData}
      setIsEditProjectModalOpen={setIsEditProjectModalOpen}
      isEditProjectModalOpen={isEditProjectModalOpen}
      onEditProjectData={onEditProject}
      onDuplicate={handleDuplicate}
      onEdit={onEdit}
      onDelete={onDelete}
      goToProject={goToProject}
      fetchCsvFile={fetchCsvFile}
      getProjectsData={getProjectsData}
    />
  );
}
